var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57143 8.57227H0V22.2865C0 24.1776 1.5375 25.7151 3.42857 25.7151H20.5714C22.4625 25.7151 24 24.1776 24 22.2865V8.57227H15.4286V13.7151C15.4286 14.6633 14.6625 15.4294 13.7143 15.4294H10.2857C9.3375 15.4294 8.57143 14.6633 8.57143 13.7151V8.57227Z",
    fill: "#0270B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.71607 3.13449C3.15536 2.26663 4.04464 1.71484 5.01964 1.71484H10.2857L8.57143 8.57199H0L2.71607 3.13449ZM15.4286 8.57199V13.7148C15.4286 14.6631 14.6625 15.4291 13.7143 15.4291H10.2857C9.3375 15.4291 8.57143 14.6631 8.57143 13.7148V8.57199H15.4286ZM15.4286 8.57199L13.7143 1.71484H18.9804C19.9554 1.71484 20.8446 2.26663 21.2786 3.13449L24 8.57199H15.4286Z",
    fill: "#0270B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.3dbda49bac287f2b33e4c1ae0d889737.svg";
export { ForwardRef as ReactComponent };